export const FAMILY_EXTENDED = `"GT America Extended Regular", "Arial", sans-serif`; // 27 instances
export const FAMILY_STANDARD = `"GT America Standard Regular", "Arial", sans-serif`; // 29 instances
export const FAMILY_STANDARD_BOLD = `"GT America Standard Bold", "Arial Black", "Arial", sans-serif`; // 12 instances
export const FAMILY_EXTENDED_BOLD = `"GT America Extended Bold", "Arial Black", "Arial", sans-serif`; // 25 instances



// WEBPACK FOOTER //
// ../src/client/styles/typography.js